import React, { useEffect, useState } from 'react';
//*MUI
import { Box, Divider, Modal } from '@mui/material';
//*files
import cssClasses from "./PreviewAgreementModal.module.css"
import Button from '../../../../Subcomponents/Button';
import Close from '../../../../Components/Icons/Close';
import CustomSwitch from '../../../../Subcomponents/CustomSwitch';
import { getPreviewAgreementToCustomer, saveUpdatedFlag } from '../../../../Services/AllAllotments';
import { dismissLoader, presentLoader } from '../../../../Services/loader';
import { errorTost, successTost } from '../../../../Services/Toast';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: "min(1300px, 100%)",
  maxHeight : "90%",
  height : "100%",
  bgcolor: 'background.paper',
  borderRadius: '8px',
  boxShadow: 24,
};

function PreviewAgreementModal({ open, handleClose, url, heading, id}) {
  const [checked, setChecked] = useState(false);

  const handleChange = (event) => {
    setChecked(event.target.checked);
    // console.log('event.target.checked', event.target.checked);
  };

  useEffect(()=>{
    getPreviewAgreementFlag()
  },[])

  async function getPreviewAgreementFlag(){
    await getPreviewAgreementToCustomer(id).then((res)=>{
      console.log("res",res);
      setChecked(res?.data?.isPreviewAgreementEnable);
    }).catch((err)=>{
      console.log(err);
    })
  }

  function save(){
    presentLoader()
    saveUpdatedFlag(id, checked).then((res) => {
      console.log("res", res);
      dismissLoader();
      successTost("Updated Successfully!")
    }).catch((err) => {
      console.log(err);
      dismissLoader();
      errorTost("Failed to update!")
    })
  }
  return (
    <>
      <Modal
        open={open}
        onClose={() => {
          handleClose();
        }}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box sx={style}>
          <Box className={cssClasses.headerDiv}>
            <Box className={cssClasses.flexRow}>
              <Box className={cssClasses.flexCol}>
                <Box className={cssClasses.flexRow}>
                  <Box className={cssClasses.HeaderTitle}>{heading}</Box>
                </Box>
              </Box>
              <Box ml={'auto'} mt={1} onClick={handleClose} style={{ cursor: "pointer" }}>
                <Close width={'1.2rem'} height={'1.2rem'} />
              </Box>
            </Box>
            <Divider/>
          </Box>
          {heading === "Preview Agreement" && 
            <Box sx={{paddingX : "3rem", border : "none", display : "flex", alignItems : "center", justifyContent : "center", gap : "1.5rem", marginBottom : "1rem"}}>
              <Box className={cssClasses.SubHeaderTitle}>
                Customer Preview : 
              </Box>
              <CustomSwitch checked={checked} onChange={handleChange} />
              <Button
                btnName={"Save"}
                style={{ 
                  color: "#344054", 
                  backgroundColor: "#ffffff",
                  width: "15rem",
                  fontSize: "1.4rem",
                  lineHeight: "2rem",
                  fontFamily: "Inter-Medium !important", 
                }}
                clicked={() => {
                  save()
                }}
              />
            </Box>
          }
          <Box sx={{height : "90%" , paddingX : "3rem", border : "none"}}> 
            <iframe width="100%" height="90%" src={url} title={heading + "url"} ></iframe> 
          </Box>  

        </Box>
      </Modal>
    </>
  )
}

export default PreviewAgreementModal;


function numberWithCommas(x) {
	return x?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ",");
}
